import type { ReactNode } from "react"
import { Icon, type IconName } from "./icons.tsx"

/**
 * 상태색 6 + 담당색 2. 담당(`owner-*`)은 "누구 일인가" 라는 **다른 축**이라 상태색을 나눠 쓰지
 * 않는다 — 같은 화면에 상태 배지와 담당 표시가 나란히 서기 때문이다(tokens.css 의 "담당 2색").
 */
export type BadgeTone =
  | "neutral"
  | "accent"
  | "ok"
  | "warn"
  | "danger"
  | "info"
  | "owner-warehouse"
  | "owner-shipper"

/**
 * 상태 배지. 색과 함께 **모양**(아이콘)도 준다 — 색만으로 구분하면 색약인 사람에게는
 * 전부 같은 배지이고, 흑백으로 인쇄한 목록에서도 구분이 사라진다.
 */
export function Badge({
  tone = "neutral",
  size = "md",
  icon,
  children,
}: {
  tone?: BadgeTone
  size?: "sm" | "md"
  icon?: IconName
  children: ReactNode
}) {
  return (
    <span className={`badge badge--${tone} badge--${size}`}>
      {icon ? <Icon name={icon} size={size === "sm" ? 11 : 12} /> : null}
      {children}
    </span>
  )
}
